import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Globe } from 'lucide-react';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'kn' ? 'en' : 'kn';
    i18n.changeLanguage(newLang);
    localStorage.setItem('language', newLang);
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className="hover:bg-stone-100 text-slate-600"
      data-testid="language-switcher"
    >
      <Globe className="w-4 h-4 mr-2" />
      {i18n.language === 'kn' ? 'English' : 'ಕನ್ನಡ'}
    </Button>
  );
}